/**
 * Link-only mode: when there are no visible fields and a linkBtnApplication URL is configured,
 * the container renders only a button that links directly to the configured URL. Any required
 * query parameters (e.g. forbund, journeyId) are authored directly on the URL in the CMS.
 */
export function isLinkOnlyMode({ linkBtnApplication, visibleFields }) {
    return !!linkBtnApplication?.Url && visibleFields.length === 0;
}
